import { createContext } from 'react';

const GridDefinitions = createContext();

export default GridDefinitions;
